import React from 'react'
import { Menu } from '@headlessui/react'

type Props = { children: React.ReactElement, items: Array<{ id: string, item: React.ReactElement, disabled?: boolean }>, originRight?: boolean, mt?: number, containerClass?: string, noOrigin?: boolean }
const Dropdown:React.FC<Props> = ({ children, items, originRight, mt = 4, containerClass = 'relative', noOrigin }) => {

  const origin = noOrigin ? '' : originRight ? 'right-0' : 'left-0'
  return (
    <div className={containerClass}>
      <Menu as='div'>
        <Menu.Button>
          {children}
        </Menu.Button>
        <Menu.Items className={`${origin} z-50 absolute mt-${mt} rounded-lg bg-white shadow-lg focus:outline-none overflow-hidden`}>
          {items.map((itemElement) => (
            <Menu.Item key={itemElement.id} disabled={itemElement.disabled}>
              {({ active }) => React.cloneElement(itemElement.item, {
                className: `${itemElement.item.props.className ?? ''} px-4 py-3 block w-full text-left ${itemElement.disabled ? '' : active ? 'bg-soft-green' : ''}`.trim(),
              })}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Menu>
    </div>
  )
}

export default Dropdown
